module.exports = [{"code":1,"name":"黑"},{"code":2,"name":"白"},{"code":3,"name":"灰"},{"code":4,"name":"红"},{"code":5,"name":"蓝"},{"code":6,"name":"黄"},{"code":7,"name":"橙"},{"code":8,"name":"棕"},{"code":9,"name":"绿"},{"code":10,"name":"紫"},{"code":11,"name":"青"},{"code":12,"name":"粉"},{"code":13,"name":"透明"},{"code":30,"name":"银"},{"code":31,"name":"金"},{"code":99,"name":"其它"}]


//////////////////
// WEBPACK FOOTER
// ./static/json/dictionary/vehicleColor.json
// module id = Fq/Q
// module chunks = 11